import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOutlinedCalendarIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M9.5 17.25C9.91421 17.25 10.25 17.5858 10.25 18C10.25 18.4142 9.91421 18.75 9.5 18.75H6.5C6.08579 18.75 5.75 18.4142 5.75 18C5.75 17.5858 6.08579 17.25 6.5 17.25H9.5ZM17.5 17.25C17.9142 17.25 18.25 17.5858 18.25 18C18.25 18.4142 17.9142 18.75 17.5 18.75H14.5C14.0858 18.75 13.75 18.4142 13.75 18C13.75 17.5858 14.0858 17.25 14.5 17.25H17.5ZM9.5 12.25C9.91421 12.25 10.25 12.5858 10.25 13C10.25 13.4142 9.91421 13.75 9.5 13.75H6.5C6.08579 13.75 5.75 13.4142 5.75 13C5.75 12.5858 6.08579 12.25 6.5 12.25H9.5ZM17.5 12.25C17.9142 12.25 18.25 12.5858 18.25 13C18.25 13.4142 17.9142 13.75 17.5 13.75H14.5C14.0858 13.75 13.75 13.4142 13.75 13C13.75 12.5858 14.0858 12.25 14.5 12.25H17.5Z",
			fill: "#30515B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.249 19.999L20.2451 10.25H3.75V20C3.75005 20.6903 4.30967 21.25 5 21.25H18.999C19.6896 21.25 20.2493 20.6896 20.249 19.999ZM15.25 6V4.75H8.75V6C8.75 6.41421 8.41421 6.75 8 6.75C7.58579 6.75 7.25 6.41421 7.25 6V4.75H5C4.30964 4.75 3.75 5.30964 3.75 6V8.75H20.2461L20.248 6.00098C20.2486 5.31025 19.6888 4.75 18.998 4.75H16.75V6C16.75 6.41421 16.4142 6.75 16 6.75C15.5858 6.75 15.25 6.41421 15.25 6ZM21.749 19.999C21.7495 21.5181 20.5182 22.75 18.999 22.75H5C3.48124 22.75 2.25005 21.5187 2.25 20V6C2.25 4.48122 3.48122 3.25 5 3.25H7.25V2C7.25 1.58579 7.58579 1.25 8 1.25C8.41421 1.25 8.75 1.58579 8.75 2V3.25H15.25V2C15.25 1.58579 15.5858 1.25 16 1.25C16.4142 1.25 16.75 1.58579 16.75 2V3.25H18.998C20.5176 3.25 21.7491 4.48244 21.748 6.00195L21.7451 9.50098L21.749 19.999Z",
			fill: "#30515B"
		})
	]
});
const ForwardRef = forwardRef(SvgOutlinedCalendarIcon);
const Memo = memo(ForwardRef);
export default Memo;
